<section *ngIf="processing">
    <h2>{{processingMessage}}...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
    </mat-progress-bar>
</section>

<section *ngIf="!processing">
    <!-- Action Buttons -->
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
            <h2 class="noMarginHeader"><mat-icon>note_add</mat-icon> Generate COC Letter ?????</h2>
        </div>
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
            <button type="submit" name="SubmitButton" (click)="onSubmit()" mat-raised-button color="primary" value="Save" title="Save">Save</button>
            &nbsp;&nbsp;
            <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel">Cancel</button>
        </div>
    </div>
    <hr />
</section>

<mat-dialog-content id="householdLetterPdf">

    <!-- English -->
    <section>
        <Header>
            <img src="{{environment.baseUrl}}/assets/images/OregonWell_Letterheader.png" alt="Letter Header">
        </Header>
        <style>
            td,
            th {
                border: 1px solid #dddddd;
                margin-left: 5.4pt;
                padding: 0in 5.4pt 0in 5.4pt
            }
        </style>

        <body style="font-family: 'Arial'; ">
            <p style='font-size:18px'>
                {{today | date: 'MMMM d, y':'':'' }}
            </p>
            <p style='color:green; font-size:22px'><br>
                {{mailingAddress}}<br>
                {{mailingCity}} {{mailingState}} {{mailingZip}}</p>
            <p></p>

            <p style='font-size:22px'>household coc letter
            </p>


        </body>
    </section>

    <br /><br />


</mat-dialog-content>